import {
    applyMiddleware, combineReducers, compose, createStore,
} from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';

const buildRootReducer = (allReducers, history) => combineReducers({ ...allReducers, router: connectRouter(history) });

export const updateStore = (store, reducers, history) => {
    store.replaceReducer(buildRootReducer(reducers, history));
};

export const configureStore = (reducers, history, initialState) => {
    const composeEnhancers = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) // eslint-disable-line no-underscore-dangle
        || compose;

    const store = createStore(
        buildRootReducer(reducers, history),
        initialState,
        composeEnhancers(
            applyMiddleware(thunk, routerMiddleware(history)),
        ),
    );

    return store;
};

const stateKey = 'ywa-state';

export const clearState = () => {
    try {
        localStorage.removeItem(stateKey);
    } catch {
        // ignore write errors
    }
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(stateKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(stateKey, serializedState);
    } catch {
        // ignore write errors
    }
};
